import { useState } from "react";
import { callInternalApi } from "./callInternalApi";

export const useRequest = <RequestData, ResponseType>(
  /** path of the function inside the /api folder (e.g. "offers/loadFrontend") */
  path: string,
  callback?: (res: ResponseType) => Promise<void> | void
) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const request = async (data: RequestData) => {
    try {
      setIsSubmitting(true);

      const res: ResponseType = await callInternalApi(path, data);

      if (callback) await callback(res);
      return res;
    } catch (err) {
      // TODO: Handle error
    } finally {
      setIsSubmitting(false);
    }
  };

  return { request, isSubmitting };
};
